import React from 'react';
import cn from 'classnames';
import { Trans } from '@lingui/macro';
import { ChangeSubscriptionPlan } from '../types';

export default function PackageCardPrices({ prices }: { prices: ChangeSubscriptionPlan }) {
    const commonClasses = 'flex justify-between text-xs px-4';
    const { packagePrice, transactionPrice, addonPrice, userPrice } = prices;

    return (
        <div className="bg-grey-100">
            <div className={cn(commonClasses, 'pt-3')}>
                <Trans>Package price</Trans>
                <div>{Math.round(packagePrice)},-</div>
            </div>
            <div className={cn(commonClasses, 'pt-2')}>
                <Trans>Transaction price</Trans>
                <div>+ {Math.round(transactionPrice)},-</div>
            </div>
            <div className={cn(commonClasses, 'pt-2')}>
                <Trans>Users</Trans>
                <div>+ {Math.round(userPrice)},-</div>
            </div>
            <div className={cn(commonClasses, 'pt-2 pb-3')}>
                <Trans>Add-ons</Trans>
                <div>+ {Math.round(addonPrice)},-</div>
            </div>
            <div className="flex justify-between font-bold text-base bg-grey-200 px-4 py-2">
                <Trans>Total price</Trans>

                <div>{Math.round(packagePrice + transactionPrice + addonPrice + userPrice)},-</div>
            </div>
        </div>
    );
}
